function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'netlify-cms-ui-default';
import { markdownToHtml } from "./serializers";
import DOMPurify from 'dompurify';
import { jsx as ___EmotionJSX } from "@emotion/core";

class MarkdownPreview extends React.Component {
  render() {
    const {
      value,
      getAsset,
      resolveWidget,
      field
    } = this.props;

    if (value === null) {
      return null;
    }

    const html = markdownToHtml(value, {
      getAsset,
      resolveWidget
    });
    const toRender = field !== null && field !== void 0 && field.get('sanitize_preview', false) ? DOMPurify.sanitize(html) : html;
    return ___EmotionJSX(WidgetPreviewContainer, {
      dangerouslySetInnerHTML: {
        __html: toRender
      }
    });
  }

}

_defineProperty(MarkdownPreview, "propTypes", {
  getAsset: PropTypes.func.isRequired,
  resolveWidget: PropTypes.func.isRequired,
  value: PropTypes.string
});

export default MarkdownPreview;